import { isValidEmail } from '../../../utils/validate';
import { isValidPassword } from '@/utils/validate';

export function validateMobile(rule, value, callback) {
  if (value.length === 0) {
    callback(new Error('Mobile is required'));
  } else if (value.length !== 10) {
    callback(new Error('Mobile must have 10 digits'));
  } else if (!value.startsWith('69')) {
    callback(new Error('Mobile must have 69XXXXXXXX format'));
  } else if (isNaN(value)) {
    callback(new Error('Mobile must be numeric'));
  } else {
    callback();
  }
}

export function validateEmail(rule, value, callback) {
  if (value.length > 0 && !isValidEmail(value)) {
    callback(new Error('Please enter a valid email'));
  } else {
    callback();
  }
}

export function validateVerificationCode(rule, value, callback) {
  if (isNaN(value)) {
    callback(new Error(' '));
  } else if (value.length !== 6) {
    callback(new Error(' '));
  } else {
    callback();
  }
}

export function validateStoresSelect(rule, value, callback) {
  if (value.length === 0) {
    callback(new Error('You must select at least one store'));
  } else if (value.length > 5) {
    callback(new Error('You can select a maximun of 5 stores'));
  } else {
    callback();
  }
}

export function validateRequiredConsent(rule, value, callback) {
  if (value !== true) {
    callback(new Error('Required'));
  } else {
    callback();
  }
}

export function validateNewPass(rule, value, callback) {
  if (!isValidPassword(value)) {
    callback(
      new Error(
        'Insert min length 8 chars, one uppercase, one digit, one special char'
      )
    );
  } else {
    callback();
  }
}



// WEBPACK FOOTER //
// ./src/components/Shared/validators/registerValidators.js